var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.winShow),expression:"winShow"}],attrs:{"id":"app"}},[(_vm.$route.meta.isGlobal)?_c('router-view'):(_vm.computeUserName)?_c('layout'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }